import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { environment } from '@environments/environment';
import {
  custFilterData,
  Customer,
  CustomerList,
  CustomerPayload,
  CustomerResultViewModel,
  CustomerViewModel,
} from '../../service/customer.model';
import { PartnerPayload } from '../../service/partner.model';
import { BaseDropdownInterface } from '@interfaces/base-dropdown.interface';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  // todo need to rewrite functionality without using filteredCustomerList$ for service.request.component
  filteredCustomerList$: BehaviorSubject<CustomerList[]> = new BehaviorSubject<CustomerList[]>([]);

  constructor(private httpClient: HttpClient) {}

  getCustomerList(flag: boolean): Observable<CustomerViewModel[]> {
    const url = `${environment.apiHost}/CustomerBU/${flag}`;

    return this.httpClient.get<CustomerViewModel[]>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getFilteredCustomerList(): Observable<CustomerList[]> {
    const url = `${environment.apiUrl}/Customer/FilteredCustomerList`;

    return this.httpClient
      .get<CustomerList[]>(url)
      .pipe(
        tap((customerList: CustomerList[]) => {
          // todo need to rewrite functionality without using filteredCustomerList$
          this.filteredCustomerList$.next(customerList);
        }),
      )
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getCustomerAddressById(customerId: string): Observable<CustomerViewModel[]> {
    const url = `${environment.apiUrl}/Customer/GetCustomerAddressById/${customerId}`;

    return this.httpClient.get<CustomerViewModel[]>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  updateCustomerDetail(customerDetail: CustomerPayload | PartnerPayload, customerId: string): Observable<CustomerViewModel[]> {
    const url = `${environment.apiHost}/CustomerBU/${customerId}`;

    return this.httpClient
      .put<CustomerViewModel[]>(url, customerDetail)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  addCustomer(customer: CustomerPayload | PartnerPayload): Observable<CustomerPayload> {
    const url = `${environment.apiHost}/CustomerBU/`;

    return this.httpClient.post<CustomerPayload>(url, customer).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getFilterData(filterData: custFilterData): Observable<CustomerResultViewModel> {
    const url = `${environment.apiHost}/CustomerBU/filter`;

    return this.httpClient
      .post<CustomerResultViewModel>(url, filterData)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  fetchCustomerListById(customerId: string): Observable<Customer> {
    const url = `${environment.apiHost}/CustomerBU/${customerId}`;

    return this.httpClient.get<Customer>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  setInvoiceSetting(data, customerId): Observable<boolean> {
    const url = `${environment.apiHost}/Finance/SaveInvoiceDescription/${customerId}`;

    return this.httpClient.post<boolean>(url, data).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  setCallFlow(callFlowData: FormData): Observable<any> {
    // todo need to figure out response model instead of using Observable<any>
    const url = `${environment.apiHost}/CallFlowAndCheckList`;

    return this.httpClient.post<any>(url, callFlowData).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  fetchCustomerPOMappingByCustomerID(customerID: string): Observable<any> {
    // todo need to figure out response model instead of using Observable<any>
    const url = `${environment.apiHost}/CustomerBU/fetchCustomerPOMapping/${customerID}`;

    return this.httpClient.get<any>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  /**
   * Returns customer using provided id
   * @param customerId
   */
  getCustomerName(customerId: string): Observable<BaseDropdownInterface> {
    const url = `${environment.apiHostV2}/customer-config/customer-name?customerId=${customerId}`;

    return this.httpClient.get<BaseDropdownInterface>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
